/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Domain_Is_TakenInputs */

const en_domain_is_taken = /** @type {(inputs: Domain_Is_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domain is taken`)
};

const es_domain_is_taken = /** @type {(inputs: Domain_Is_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El dominio ya está en uso`)
};

const fr_domain_is_taken = /** @type {(inputs: Domain_Is_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le domaine est déjà pris`)
};

const de_domain_is_taken = /** @type {(inputs: Domain_Is_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domain ist vergeben`)
};

const ja_domain_is_taken = /** @type {(inputs: Domain_Is_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ドメインはすでに使用されています`)
};

const zh_domain_is_taken = /** @type {(inputs: Domain_Is_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`域名已被占用`)
};

const ar_domain_is_taken = /** @type {(inputs: Domain_Is_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`النطاق محجوز`)
};

const id_domain_is_taken = /** @type {(inputs: Domain_Is_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domain sudah digunakan`)
};

const it_domain_is_taken = /** @type {(inputs: Domain_Is_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il dominio è occupato`)
};

const ru_domain_is_taken = /** @type {(inputs: Domain_Is_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Домен занят`)
};

const pt_domain_is_taken = /** @type {(inputs: Domain_Is_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O domínio já está em uso`)
};

const ko_domain_is_taken = /** @type {(inputs: Domain_Is_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`도메인이 이미 사용 중입니다`)
};

/**
* | output |
* | --- |
* | "Domain is taken" |
*
* @param {Domain_Is_TakenInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const domain_is_taken = /** @type {((inputs?: Domain_Is_TakenInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Domain_Is_TakenInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_domain_is_taken(inputs)
	if (locale === "es") return es_domain_is_taken(inputs)
	if (locale === "fr") return fr_domain_is_taken(inputs)
	if (locale === "de") return de_domain_is_taken(inputs)
	if (locale === "ja") return ja_domain_is_taken(inputs)
	if (locale === "zh") return zh_domain_is_taken(inputs)
	if (locale === "ar") return ar_domain_is_taken(inputs)
	if (locale === "id") return id_domain_is_taken(inputs)
	if (locale === "it") return it_domain_is_taken(inputs)
	if (locale === "ru") return ru_domain_is_taken(inputs)
	if (locale === "pt") return pt_domain_is_taken(inputs)
	return ko_domain_is_taken(inputs)
});